module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAe0lEQVR42u3aMREAIQwAwVigeQk0iMThz+CHmWAiXbY4A1tfZGZ0LgAAAAAAAAAAAAAAaA4Qa2dl93yl/WOWBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHQCcIoCAAAAAAAAAAAAANCqB2EPTVmdnGbKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Romania.png
// module id = 6lWR
// module chunks = 0 62 63